import React from "react";
import { Helmet } from "react-helmet-async";
import "./privacy-policy.css";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/hero3.png";
import { color } from "framer-motion";

const TermsConditions = () => {
  return (
    <div className="privacy-wrapper">

      {/* SEO */}
      <Helmet>
        <title>Terms and Conditions | Customersupports24x7</title>
        <meta
          name="description"
          content="Review the terms and conditions for using Customersupports24x7 appliance repair services in Bangalore."
        />
        <meta
          name="keywords"
          content="terms and conditions, appliance repair service terms"
        />
        <meta property="og:title" content="Terms and Conditions | Customersupports24x7" />
        <meta
          property="og:description"
          content="Review the terms and conditions for using Customersupports24x7 appliance repair services in Bangalore."
        />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content="https://customersupports24x7.in/terms" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Terms and Conditions | Customersupports24x7" />
        <meta
          name="twitter:description"
          content="Review the terms and conditions for using Customersupports24x7 appliance repair services in Bangalore."
        />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />
        <link rel="canonical" href="https://customersupports24x7.in/terms" />
      </Helmet>

      {/* Banner */}
      <InnerBanner title="Terms & Conditions" bgImage={serviceBg} />

      {/* Content */}
      <div className="privacy-container">

        <h1 className="privacy-title" style={{ color: '#ff0000' }}>📄 Terms & Conditions</h1>

        <p><strong>Effective Date:</strong> 26 March 2026</p>

        <p style={{ textAlign: 'justify' }}>
          By using our appliance repair services, you agree to the following terms and conditions.
          Please read them carefully before booking a service.
        </p>

        {/* 1 */}
        <h2>1. Service Booking</h2>
        <ul style={{ textAlign: 'justify' }}>
          <li>Customers must provide accurate information while booking a service</li>
          <li>Service appointments depend on technician availability</li>
          <li>We reserve the right to reschedule or cancel bookings if required</li>
        </ul>

        {/* 2 */}
        <h2>2. Pricing & Payments</h2>
        <ul style={{ textAlign: 'justify' }}  >
          <li>Inspection/visiting charges may apply</li>
          <li>Final repair cost depends on issue and spare parts required</li>
          <li>All payments must be completed after service</li>
        </ul>

        {/* 3 */}
        <h2>3. Warranty Policy</h2>
        <ul style={{ textAlign: 'justify' }}>
          <li>Warranty is applicable only on replaced spare parts</li>
          <li>Warranty does not cover misuse, physical damage, or external factors</li>
        </ul>

        {/* 4 */}
        <h2>4. Service Disclaimer</h2>
        <ul style={{ textAlign: 'justify' }}>
          <li>Customers must back up their data before service</li>
          <li>We are not responsible for pre-existing issues or hidden faults</li>
        </ul>

        {/* 5 */}
        <h2>5. Cancellation Policy</h2>
        <ul style={{ textAlign: 'justify' }}>
          <li>Free cancellation before technician is dispatched</li>
          <li>Cancellation charges may apply after dispatch</li>
        </ul>

        {/* 6 */}
        <h2>6. Limitation of Liability</h2>
        <p  style={{ textAlign: 'justify' }}>
          We are not liable for any indirect, incidental, or consequential damages arising from the use of our services.
        </p>

        {/* 7 */}
        <h2>7. Changes to Terms</h2>
        <p  style={{ textAlign: 'justify' }}>
          We may update these Terms & Conditions from time to time. Changes will be posted on this page.
        </p>

        {/* 8 */}
        <h2>8. Contact Information</h2>
       <div className="cta-box">
  📞 
  <a href="tel:8050731754" style={{ color: "inherit", textDecoration: "none" }}>
    8050731754
  </a>
  <br />

  📧 
  <a href="mailto:info@customersupport24x7.in" style={{ color: "inherit", textDecoration: "none" }}>
    info@customersupport24x7.in
  </a>
</div>

      </div>
    </div>
  );
};

export default TermsConditions;

